// extracted by mini-css-extract-plugin
export default {"FontThemeMappingContainer":"FontThemeMappingsForm_FontThemeMappingContainer__eTuAs"};